export interface IJavascriptStorage {
    getItem(key: string): string;
    setItem(key: string, data: string): void;
    removeItem(key: string): void;
}

/** Wrapper of storage to allow different implementation inside mobile app */
export function createStorageWithSessionStorage(): IJavascriptStorage {

    const getItem = (key: string): string => {
        return window.sessionStorage.getItem(key);
    }

    const setItem = (key: string, data: string): void => {
        window.sessionStorage.setItem(key, data);
    }

    const removeItem = (key: string): void => {
        window.sessionStorage.removeItem(key);
    }

    return {
        getItem,
        setItem,
        removeItem
    }
}

/** Wrapper of storage to allow different implementation inside mobile app */
export function createStorageWithLocalStorage(): IJavascriptStorage {

    const getItem = (key: string): string => {
        return window.localStorage.getItem(key);
    }

    const setItem = (key: string, data: string): void => {
        window.localStorage.setItem(key, data);
    }

    const removeItem = (key: string): void => {
        window.localStorage.removeItem(key);
    }

    return {
        getItem,
        setItem,
        removeItem
    }
}
